import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
const TextCircle = ({ outlined, innerText, wrapperStyle, textStyle, className, }) => (_jsx(Box, { sx: {
        textAlign: 'center',
        borderRadius: '50%',
        backgroundColor: (theme) => {
            if (className === 'courseProgressIconColor') {
                return (
                // eslint-disable-next-line max-len
                theme.portal?.courseDeliveryPage?.courseProgressIconColor || theme.palette.success.main);
            }
            return outlined ? 'transparent' : 'primary.main';
        },
        width: outlined ? 36 : 40,
        minWidth: outlined ? 36 : 40,
        height: outlined ? 36 : 40,
        border: outlined ? 2 : 'none',
        borderColor: outlined ? 'primary.main' : 'none',
        ...wrapperStyle,
    }, children: _jsx(Typography, { component: "span", sx: {
            height: outlined ? 36 : 40,
            lineHeight: outlined ? '34px' : '40px',
            fontSize: (theme) => theme.typography.subtitle1.fontSize,
            fontWeight: 'fontWeightBold',
            color: (theme) => (theme.portal?.courseDeliveryPage?.courseProgressTextColor),
            letterSpacing: 'normal',
            ...textStyle,
        }, children: innerText || '--' }) }));
TextCircle.defaultProps = {
    outlined: false,
    wrapperStyle: {},
    textStyle: {},
    className: null,
};
export default TextCircle;
//# sourceMappingURL=TextCircle.js.map